import { Box } from "@mui/material";
import {
  AppPagination,
  HeadingText,
  ParagraphText,
} from "../../../../../Libraries";
import { useContext, useEffect } from "react";
import withObservables from "@nozbe/with-observables";
import StockHistoryTableRow from "./StockHistoryTableRow";
import { LanguageContext } from "../../../../../context/LanguageContext";
import { Q } from "@nozbe/watermelondb";
import { sentenceCase } from "../../../../../constants";
import NonIdealNew from "../../../../common/NonIdealNew";

const StockHistory = ({
  inventory,
  product,
  setPage,
  invCount,
  list,
  setList,
  page,
}) => {
  const [I18n] = useContext(LanguageContext);

  const StockHistoryListTableHeads = [
    { name: I18n.type, columnClassName: "justifyStart" },
    { name: I18n.date, columnClassName: "justifyStart" },
    { name: I18n.time, columnClassName: "justifyStart" },
    { name: I18n.stock, columnClassName: "justifyStart" },
    { name: I18n.amount, columnClassName: "justifyEnd" },
  ];

  useEffect(() => {
    setList(page == 0 ? inventory : [...list, ...inventory]);
  }, [inventory]);

  return (
    <Box className="StockHistoryWrapper">
      <Box
        display={"flex"}
        alignItems={"center"}
        height={"47px"}
        padding={"0px 24px"}
      >
        <HeadingText className={"fontSize18 fontWeight500 mainColor"}>
          {sentenceCase(I18n.stock_history)}
        </HeadingText>
      </Box>

      <Box className="StockHistoryTableContainer">
        <div className="invoiceListTableHeader w-100">
          {StockHistoryListTableHeads.map(({ name, columnClassName }, ind) => (
            <ParagraphText
              className={`ItemListTableHeaderColumn fontSize12 fontWeight500 newLightColor ${columnClassName}`}
              key={name}
            >
              {name}
            </ParagraphText>
          ))}
        </div>
        <div
          className="detailItemListTableBodyWrapper generic-scrollbar"
          id="scrollableDiv"
        >
          {list?.length ? (
            <AppPagination
              data={{
                handleNext: (e) => setPage((prev) => prev + 1),
                pageLoad: true,
                count: invCount,
                list: list,
                scrollableTarget: "scrollableDiv",
              }}
            >
              {list
                ?.sort(
                  (a, b) =>
                    new Date(b.transacted_at) - new Date(a.transacted_at),
                )
                .map((item, ind) => (
                  <StockHistoryTableRow
                    item={item}
                    product={product}
                    key={ind}
                  />
                ))}
            </AppPagination>
          ) : (
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              height={"100%"}
            >
              <Box className="stockHistorynonIdealContainer" width={"300px"} alignSelf={"center"}>
                <NonIdealNew
                  title={I18n.no_stock_history_yet}
                  subtitle={
                    I18n.stock_changes_will_appear_here_one_you_start_adding
                  }
                  loading={false}
                />
              </Box>
            </Box>
          )}
        </div>
      </Box>
    </Box>
  );
};

const enhance = withObservables(
  ["product", "page", "ITEMS_PER_PAGE"],
  ({ product, page, ITEMS_PER_PAGE }) => {
    const limit = ITEMS_PER_PAGE;
    const offset = ITEMS_PER_PAGE * page;

    return {
      inventory: product
        .getInvByDate(undefined, undefined, limit, offset)
        .extend(Q.sortBy("transacted_at", Q.desc))
        .observe(),
      invCount: product.getInvByDate(undefined, undefined).observeCount(),
    };
  },
);

export default enhance(StockHistory);
